let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("937Yn")).then(() => parcelRequire('6ePd1'));